import React from 'react';
import { ActivityTimeline } from './pages/ActivityTimeline';
interface AppProps {
  /** Row height and metadata shown in the timeline. */
  density?: 'comfortable' | 'compact';
}
export function App({
  density = 'comfortable'
}: AppProps) {
  return <div className="min-h-full w-full bg-canvas font-sans text-ink" data-id="element-0" data-mp="3k7i5r8vye84a">
      <ActivityTimeline density={density} data-id="element-1" data-mp="3fbt3uywgof4t" />
    </div>;
}